// src/components/Header.jsx (New Style)

import React, { useState } from 'react';
// Assuming your logo file is accessible via this path
import DevulexIcon from './logo7.png'; 

const Header = ({ companyName }) => { 
  const [isOpen, setIsOpen] = useState(false);

  // Toggle function for the hamburger button
  const handleToggle = () => setIsOpen(!isOpen);
  // Function to close the menu after a link is clicked
  const handleLinkClick = () => setIsOpen(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Achievements', href: '#achievements' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="new-navbar">
      <div className="navbar-inner-container">
        
        {/* --- Logo/Branding (Centerpiece) --- */}
      <div className="logo-section">
    <a href="#home" className="logo-link" onClick={handleLinkClick}>
        <img 
            src={DevulexIcon} 
            alt={`${companyName} Logo`} 
            className="logo-icon" 
            style={{ 
                height: '60px', // Increase the height (adjust as needed, e.g., '45px', '60px')
                width: 'auto', // Keep width auto to maintain aspect ratio
                marginRight: '12px' 
            }}
        />
        <span 
            className="logo-text"
            style={{ 
                fontSize: '1em', // Slightly increase text size to match larger icon
                fontWeight: '800' // Make text bold/heavy
            }}
        >
            {companyName}
        </span>
    </a>
</div>

        {/* --- Hamburger Button (Visible on mobile) --- */}
        <button
          className="menu-toggle-btn"
          onClick={handleToggle}
          aria-expanded={isOpen}
          aria-label="Open menu"
        >
          {isOpen ? '✕' : '☰'}
        </button>

        {/* --- Navigation Menu --- */}
        <nav className={`nav-links-menu ${isOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a href={link.href} onClick={handleLinkClick}>{link.name}</a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;